/**
 * Die Anwendertexte von Verwaltung › Einheiten (Spec Artikelmodul 0.4, „Verwaltung › Einheiten (779)“): englische
 * Schlüssel, deutsche Werte. Die Fehlertexte des Servers stehen in der Domäne (`PRODUCT_TEXT`).
 */
export const UNIT_TEXT = {
  listLabel: "Einheiten",
  newUnit: "Neue Einheit",
  editTitle: (name: string): string => `Einheit „${name}“ bearbeiten`,
  /** Zugänglicher Name einer Zeile — der Klick öffnet das Panel zum Bearbeiten. */
  row: (name: string, verwendung: string): string => `Einheit ${name}, ${verwendung}, bearbeiten`,
  usage: (n: number): string => `${n} Artikel`,
  inactive: "stillgelegt",
  name: "Name",
  code: "UN/ECE-Code",
  sortIndex: "Reihenfolge",
  inactiveLabel: "Stillgelegt",
  /** Der Schaltertext nennt die Wirkung (131). */
  inactiveEffect: "Für neue Artikel nicht mehr wählbar",
  codeHelp: "Zwei oder drei Zeichen, etwa MON, H87 oder C62; leer, wenn es keinen gibt.",
  sortHelp: "Kleinere Zahlen stehen in der Auswahl weiter oben; leer hängt eine neue Einheit hinten an.",
  confirmSave: (name: string): string => `Einheit „${name}“ speichern?`,
  confirmCreate: (name: string): string => `Neue Einheit „${name}“ anlegen?`,
  confirmDeactivate: (name: string): string => `Einheit „${name}“ stilllegen?`,
  deactivateConsequence: "Sie ist dann für neue Artikel nicht mehr wählbar; Artikel, die sie tragen, behalten sie.",
  saveConsequence: "Die Einheit gilt für die Artikel aller Unternehmen.",
  confirmDelete: (name: string): string => `Einheit „${name}“ löschen?`,
  deleteConsequence: "Sie wird von keinem Artikel genutzt und lässt sich nicht wiederherstellen.",
  deleteFailed: "Die Einheit konnte nicht gelöscht werden.",
  sortInvalid: "Die Reihenfolge muss eine ganze Zahl ab 0 sein.",
  yes: "Ja",
  no: "Nein",
  save: "Speichern",
  cancel: "Abbrechen",
  remove: "Löschen",
  loading: "Lädt …",
  empty: "Es sind noch keine Einheiten hinterlegt.",
} as const;
